<template>

    <RentalsListingsShell>
        <HugeSpinner v-if="loadingRental"/>
        <div v-else>
            <RentalDetailsCard :data="rentalDetails.rental" :isHistoric="isHistoric"/>
            <PeerCard :user="rentalDetails.peer" :visibleAddress="false" class="mt3 mt4-ns"/>
            <ToolDetailsCard :listing="rentalDetails.listing" class="mt3 mt4-ns"/>
        </div>
    </RentalsListingsShell>

</template>

<script>
import RentalsListingsShell from '@/components/rentalsListings/shared/RentalsListingsShell.vue';
import RentalDetailsCard from '@/components/rentalsListings/shared/RentalDetailsCard.vue';
import PeerCard from '@/components/rentalsListings/shared/PeerCard.vue';
import ToolDetailsCard from '@/components/rentalsListings/shared/ToolDetailsCard.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        RentalsListingsShell,
        RentalDetailsCard,
        PeerCard,
        ToolDetailsCard,
        HugeSpinner
    },
    props: {
        isHistoric: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('rentals', ['rentalDetails', 'loadingRental'])
    },
    methods: {
        ...mapActions('rentals', ['getRental'])
    },
    watch: {
        $route() {
            this.getRental(this.$route.params.id);
        }
    },
    created: function() {
        this.getRental(this.$route.params.id);
    }
};
</script>
